import { render } from "./SVGClose.vue?vue&type=template&id=35195a87"
import script from "./SVGClose.vue?vue&type=script&lang=js"
export * from "./SVGClose.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__